import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import axios from 'axios';
import config from '../../config';

const FIELD_TYPES = [
  "text",
  "number",
  "textarea",
  "radio",
  "checkbox",
  "select",
  "date",
  "datetime",
];

const OPTION_TYPES = ["radio", "checkbox", "select"];

const Openformmodal = ({
  show,
  onClose,
  onImagetimeline,
  onSubmitpost,
  fetchinputs,
  inputData,
  onSave,
  getforms
}) => {

  const [activeTab, setActiveTab] = useState("edit");
  const [project, setProject] = useState('');
  const [projectError, setProjectError] = useState('');
  const [wing, setWing] = useState('');
  const [wingError, setWingError] = useState('');
  const [filteredWings, setFilteredWings] = useState([]);

  const uniqueProjects = Array.from(
    new Map(
      inputData.map(item => [
        item.projectId,
        { id: item.projectId, name: item.projectName }
      ])
    ).values()
  );

  const handleProjectChange = e => {
    const selectedProjectId = e.target.value;
    setProject(selectedProjectId);
    setProjectError('');
    setWing('');

    const wings = inputData.filter(
      item => String(item.projectId) === String(selectedProjectId)
    );
    setFilteredWings(wings);
  };

  const handleWingChange = e => {
    console.log(e.target.value);
    setWing(e.target.value);
    if (e.target.value) setWingError('');
  };

  const [form, setForm] = useState({
    title: "",
    description: "",
    submitButtonText: "",
    fields: [],
  });

  if (!show) return null;

  const addField = () => {
    setForm({
      ...form,
      fields: [
        ...form.fields,
        {
          id: `field_${Date.now()}`,
          label: "",
          type: "text",
          required: false,
          placeholder: "",
          options: [],
        },
      ],
    });
  };

  const updateField = (index, key, value) => {
  const fields = [...form.fields];

  // If type changes, reset options if new type doesn't accept options
  if (key === "type" && !OPTION_TYPES.includes(value)) {
    fields[index].options = [];
  }

  fields[index][key] = value;

  // Ensure options is always an array
  if (!fields[index].options) fields[index].options = [];

  setForm({ ...form, fields });
};

  const removeField = (index) => {
    const fields = [...form.fields];
    fields.splice(index, 1);
    setForm({ ...form, fields });
  };

  const moveFieldUp = (index) => {
    if (index === 0) return;
    const fields = [...form.fields];
    [fields[index - 1], fields[index]] = [fields[index], fields[index - 1]];
    setForm({ ...form, fields });
  };

  const moveFieldDown = (index) => {
    if (index === form.fields.length - 1) return;
    const fields = [...form.fields];
    [fields[index + 1], fields[index]] = [fields[index], fields[index + 1]];
    setForm({ ...form, fields });
  };

  const handleforms = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    if (!project || !wing) {
      toast.error("Project and Wing are required");
      return;
    }

    if (!form.title.trim()) {
      toast.error("Form title required");
      return;
    }

    if (!form.fields.length) {
      toast.error("At least one field required");
      return;
    }

    if (form.fields.map((item) => item.label.trim()).filter((item) => item.length === 0).length > 0) {
      toast.error("Labels for all Fields are required");
      return;
    }
    

    const payload = {
      ProjectID: Number(project),
      wing: wing,
      Data: {
        title: form.title,
        description: form.description,
        submittext: form.submitButtonText,
        fields: form.fields.map(f => ({
          id:f.label.trim().replaceAll(' ', '_').toLowerCase(),
          label: f.label,
          type: f.type,
          required: f.required,
          placeholder: f.placeholder || "",
          options: OPTION_TYPES.includes(f.type)
            ? (f.options || []).map(o => o.trim()).filter(Boolean)
            : []
        }))
      }
    };

   try {
  const res = await axios.post(
    `${config.apiUrl}/post/Form`,
    payload,
    {
      headers: {
        Authorization: token,
        "Content-Type": "application/json"
      }
    }
  );

  toast.success("Form saved successfully");
  await getforms();

  
  const savedFormId = res.data?.Data?.FormID || Date.now(); 

  onSave({
    id: savedFormId,
    title: form.title,
    description: form.description,
    submitButtonText: form.submitButtonText,
    fields: form.fields.map((f, index) => ({
      id: `${savedFormId}-${index}`, 
      label: f.label,
      type: f.type,
      required: f.required,
      placeholder: f.placeholder || "",
      options: OPTION_TYPES.includes(f.type)
        ? (f.options || []).map(o => o.trim()).filter(Boolean)
        : []
    }))
  });

  onClose();
} catch (err) {
  console.error(err); // log actual error
  toast.error(err.response?.data?.message || "Failed to save form");
}
  }

  const resetForm = () => {
    setForm({
      title: "",
      description: "",
      submitButtonText: "",
      fields: [],
    })
    setActiveTab("edit");
    setProject('');
    setProjectError('');
    setWing('');
    setWingError('');
    setFilteredWings([]);
    document.getElementById('createForm').reset();
  }


  return (
    <>
      <Modal
        show={show}
        onHide={onClose}
        centered
        scrollable
        backdrop="static"
        size="lg"
        aria-labelledby="form-modal-title"
      >
            <form onSubmit={handleforms} id='createForm'>
            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title" id="form-modal-title">Create Form</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
            </div>

            {/* BODY */}
            <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">
                    Select Project <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={project}
                    onChange={handleProjectChange}
                  >
                    <option value="">Choose Project</option>
                    {uniqueProjects.map(p => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                  {projectError && (
                    <div className="alert alert-danger mt-2">
                      {projectError}
                    </div>
                  )}
                </div>

                  <div className="mb-3">
                  <label className="form-label">
                    Select Wing <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={wing}
                    onChange={handleWingChange}
                    disabled={!project}
                  >
                    <option value="">Choose Wing</option>
                    {filteredWings.map(w => (
                      <option key={w.wingId} value={w.wingId}>
                        {w.wingName}
                      </option>
                    ))}
                  </select>
                  {wingError && (
                    <div className="alert alert-danger mt-2">{wingError}</div>
                  )}
                </div>
            

              {/* Tabs */}
              <div className="tabs mb-3">
                <button
                  type="button"
                  className={activeTab === "edit" ? "active" : ""}
                  onClick={() => setActiveTab("edit")}
                >
                  Edit Form
                </button>

                <button
                  type="button"
                  className={activeTab === "preview" ? "active" : ""}
                  onClick={() => setActiveTab("preview")}
                >
                  Preview Form
                </button>
              </div>

              {activeTab === "edit" && (
                <>
                  <input
                    placeholder="Form Title"
                    className="form-control mb-2"
                    value={form.title}
                    onChange={(e) =>
                      setForm({ ...form, title: e.target.value })
                    }
                  />

                  <textarea
                    placeholder="Form Description"
                    className="form-control mb-2"
                    value={form.description}
                    onChange={(e) =>
                      setForm({ ...form, description: e.target.value })
                    }
                  />

                  <input
                    placeholder="Submit Button Text"
                    className="form-control mb-3"
                    value={form.submitButtonText}
                    onChange={(e) =>
                      setForm({ ...form, submitButtonText: e.target.value })
                    }
                  />

                  <h5>Fields</h5>

                  {form.fields.map((field, index) => (
                    <div className="border p-2 mb-2" key={field.id}>
                      <input
                        className="form-control mb-2"
                        placeholder="Field Label"
                        value={field.label}
                        onChange={(e) =>
                          updateField(index, "label", e.target.value)
                        }
                      />

                      <div className="d-flex gap-2 mb-2">
                        <select
                          className="form-control"
                          value={field.type}
                          onChange={(e) =>
                            updateField(index, "type", e.target.value)
                          }
                        >
                          {FIELD_TYPES.map((t) => (
                            <option key={t}>{t}</option>
                          ))}
                        </select>

                        <label className="d-flex align-items-center gap-1">
                          <input
                            type="checkbox"
                            checked={field.required}
                            onChange={(e) =>
                              updateField(index, "required", e.target.checked)
                            }
                          />
                          Required
                        </label>
                      </div>

                      {(field.type === "text" ||
                        field.type === "number" ||
                        field.type === "textarea") && (
                        <input
                          className="form-control mb-2"
                          placeholder="Placeholder"
                          value={field.placeholder || ""}
                          onChange={(e) =>
                            updateField(index, "placeholder", e.target.value)
                          }
                        />
                      )}

                      {(field.type === "radio" ||
                        field.type === "checkbox" ||
                        field.type === "select") && (
                        <textarea
                          className="form-control mb-2"
                          placeholder="Options (comma separated)"
                          value={(field.options || []).join(",")}
                          onChange={(e) =>
                            updateField(
                              index,
                              "options",
                              e.target.value.split(",")
                            )
                          }
                        />
                      )}

                      <div className="d-flex gap-2">
                        <button type="button" className='btn btn-secondary' onClick={() => moveFieldUp(index)}>↑</button>
                        <button type="button" className='btn btn-secondary' onClick={() => moveFieldDown(index)}>↓</button>
                        <button type="button" className='btn btn-danger' onClick={() => removeField(index)}>Remove</button>
                      </div>
                    </div>
                  ))}

                  <button
                    type="button"
                    className="btn btn-primary mt-2"
                    onClick={addField}
                  >
                    ➕ Add Field
                  </button>

                  <hr />

                  <button
                    type="submit"
                    className="btn btn-success w-100"
                  >
                    💾 Save Form
                  </button>
                </>
              )}
              

              {activeTab === "preview" && <PreviewForm form={form} />}
              
            </div>
            </form>
      </Modal>
    </>
  );
};

function PreviewForm({ form }) {
  return (
    <form>
      <h2>{form.title}</h2>
      <p>{form.description}</p>

      {form.fields.map((f) => (
        <div key={f.id} style={{ marginBottom: 10 }}>
          <div className="w-100">
            <label className="form-label">
              {f.label} {f.required ? '*' : ''}
            </label>
          </div>

          {f.type === "text" && <input className="form-control" />}
          {f.type === "number" && <input className="form-control" type="number" />}
          {f.type === "textarea" && <textarea className="form-control" />}
          {f.type === "date" && <input className="form-control" type="date" />}
          {f.type === "datetime" && <input className="form-control" type="datetime-local" />}

          {(f.type === "radio" || f.type === "checkbox") &&
           (f.options && f.options.length > 0) &&
  f.options.map((o, i) => (
              <div className="form-check" key={i}>
                <input
                  className="form-check-input"
                  type={f.type}
                  name={f.type === "checkbox" ? `${f.id}[]` : f.id}
                  id={`${f.id}_${i}`}
                  disabled
                />
                <label className="form-check-label" htmlFor={`${f.id}_${i}`}>
                  {o}
                </label>
              </div>
            ))}

          {f.type === "select" && (
            <select className="form-control" disabled>
              <option value="">Select</option>
              {f.options?.map((o, i) => (
                <option key={i}>{o}</option>
              ))}
            </select>
          )}
        </div>
      ))}

      <button type="submit" className="btn btn-primary">
        {form.submitButtonText || "Save"}
      </button>
    </form>
  );
}



export default Openformmodal;
